/* Notable note generator.
 * Built-in message bank by default. If the section has an AI endpoint, it POSTs
 *   { to, from, occasion, tone, details }  and expects  { message }  back, and falls back to the bank on any error.
 * "Save to my order" stores the note on the cart as attributes: "Gift note", "Note to", "Note from".
 */
(function () {
  var BANK = {
    birthday: {
      warm: [
        'Happy birthday! I hope today is full of flowers, cake and everyone who loves you.',
        'Wishing you a birthday as lovely as you are. Enjoy every moment of it.',
        'Happy birthday! Thank you for being the kind of person who makes life brighter.'
      ],
      heartfelt: [
        'Another year of you is something to celebrate. I am so grateful you are in my life.',
        'On your birthday I just want you to know how much you mean to me. Happy birthday.',
        'You make the world warmer for everyone around you. May this year give all of that back to you.'
      ],
      playful: [
        'Happy birthday! Another year older and still looking fabulous. Eat the cake.',
        'Congratulations on another trip around the sun. These flowers are your reward.',
        'It is your day, so no rules. Flowers, cake, repeat. Happy birthday!'
      ],
      short: ['Happy birthday! Enjoy every moment.', 'Wishing you a beautiful birthday.', 'Happy birthday. You deserve flowers.'],
      formal: [
        'Wishing you a very happy birthday and a year filled with good health and happiness.',
        'Please accept my warmest wishes on your birthday.',
        'Happy birthday. May the year ahead bring you every success and joy.'
      ]
    },
    congratulations: {
      warm: [
        'Congratulations! I am so happy for you and so proud of everything you have achieved.',
        'You did it! Wishing you every success as you step into this next chapter.',
        'What wonderful news. Congratulations, you truly deserve this.'
      ],
      heartfelt: [
        'I have watched how hard you worked for this, and I could not be prouder. Congratulations.',
        'This moment is yours, and it is so well earned. I am cheering for you, always.',
        'Congratulations. Seeing you succeed makes my heart so full.'
      ],
      playful: [
        'Look at you, absolutely smashing it! Congratulations. Drinks are on you.',
        'Congratulations! Please enjoy this moment, and these flowers, to the fullest.',
        'You did the thing! Celebrate loudly. Congratulations!'
      ],
      short: ['Congratulations! So proud of you.', 'You did it. Congratulations!', 'Well done, and well deserved.'],
      formal: [
        'Congratulations on your outstanding achievement. Well done.',
        'Please accept my warmest congratulations on this wonderful milestone.',
        'Heartfelt congratulations. Wishing you continued success.'
      ]
    },
    anniversary: {
      warm: [
        'Happy anniversary! Thank you for every year and every reason to smile.',
        'Here is to us, and to all the years still to come. Happy anniversary.',
        'Another year together and I would choose you all over again. Happy anniversary.'
      ],
      heartfelt: [
        'Still choosing you, every single day. Happy anniversary, my love.',
        'You are my favourite part of every year. Thank you for loving me the way you do.',
        'After all this time, you are still my home. Happy anniversary.'
      ],
      playful: [
        'Happy anniversary! Somehow you still put up with me. Thank you.',
        'Another year of me being right and you being wonderful. Happy anniversary!',
        'Cheers to us. Still the best decision I ever made. Happy anniversary!'
      ],
      short: ['Happy anniversary. Still yours.', 'Here is to us.', 'Happy anniversary, my love.'],
      formal: [
        'Warmest wishes on your anniversary and for many happy years ahead.',
        'Congratulations on another wonderful year together. Happy anniversary.',
        'Wishing you both a very happy anniversary.'
      ]
    },
    baby: {
      warm: [
        'Welcome to the world, little one. Congratulations to you both.',
        'So much love for your beautiful new family. Congratulations!',
        'What a joyful arrival. Wishing you all the happiness in the world.'
      ],
      heartfelt: [
        'Your family has grown, and so has the love in the world. Congratulations on your precious new arrival.',
        'I am so happy for you. Your little one is so lucky to have you.',
        'A new life, a new chapter, and so much love ahead. Congratulations.'
      ],
      playful: [
        'Congratulations! Sleep is overrated anyway. Enjoy every tiny toe.',
        'Welcome, tiny human. Your parents are about to be so tired and so happy.',
        'Congratulations on the newest and cutest member of the family!'
      ],
      short: ['Congratulations on your new arrival!', 'Welcome, little one.', 'So happy for you all.'],
      formal: [
        'Warmest congratulations on the arrival of your baby.',
        'Please accept my best wishes on the birth of your child.',
        'Congratulations to you and your family on your new addition.'
      ]
    },
    getwell: {
      warm: [
        'Thinking of you and wishing you a speedy recovery.',
        'Sending you strength and fresh flowers. Get well soon.',
        'Rest up and be gentle with yourself. We are all rooting for you.'
      ],
      heartfelt: [
        'You are in my thoughts every day. I hope each one brings you a little more strength.',
        'Please take all the time you need. I am here for anything at all.',
        'Sending you love, comfort and every good wish for a full recovery.'
      ],
      playful: [
        'Get well soon! The world is far too boring without you in it.',
        'Doctor’s orders: rest, flowers and absolutely no hurrying. Get well soon!',
        'We miss you. Please recover quickly. These flowers are not a good conversationalist.'
      ],
      short: ['Get well soon.', 'Thinking of you.', 'Sending healing thoughts.'],
      formal: [
        'Wishing you a swift and complete recovery.',
        'Please accept my best wishes for your speedy return to good health.',
        'Thinking of you and hoping you are well soon.'
      ]
    },
    sympathy: {
      warm: [
        'With deepest sympathy. You are in our thoughts.',
        'Holding you close in this difficult time.',
        'May beautiful memories bring you comfort.'
      ],
      heartfelt: [
        'I am so sorry for your loss. I am here for you in any way you need.',
        'There are no words, only love. Please know I am thinking of you.',
        'Their memory will live on in the lives they touched. I am with you.'
      ],
      short: ['With deepest sympathy.', 'Thinking of you.', 'Holding you in our thoughts.'],
      formal: [
        'Please accept my sincere condolences on your loss.',
        'With heartfelt sympathy to you and your family.',
        'My thoughts are with you and your family at this sad time.'
      ]
    }
  };
  BANK.justbecause = {
    warm: [
      'Just a little something to brighten your day.',
      'No reason at all, except that you are lovely and you crossed my mind.',
      'Sending you flowers, because you deserve them.'
    ],
    heartfelt: [
      'I was thinking of you today and wanted you to know how much you matter to me.',
      'You are in my thoughts more often than you know. Thank you for being you.',
      'No occasion needed. I am just so glad you are in my life.'
    ],
    playful: [
      'Surprise! No occasion, no reason, just flowers. You are welcome.',
      'These flowers have no agenda. They just think you are great.',
      'Plot twist: you got flowers on an ordinary day.'
    ],
    short: ['Thinking of you.', 'Just because.', 'You crossed my mind.'],
    formal: [
      'With warm regards, and a little something to brighten your day.',
      'Please accept these flowers as a token of my appreciation.',
      'Thinking of you, with best wishes.'
    ]
  };
  BANK.sympathy.playful = BANK.sympathy.warm;

  var SALUTE = { warm: 'Dear', heartfelt: 'Dear', playful: 'Hey', short: 'Dear', formal: 'Dear' };
  var SIGN = { warm: 'With love,', heartfelt: 'Always,', playful: 'Cheers,', short: '', formal: 'Kind regards,' };
  var counters = {};

  function localMessage(p) {
    var list = (BANK[p.occasion] && (BANK[p.occasion][p.tone] || BANK[p.occasion].warm)) || BANK.birthday.warm;
    var k = p.occasion + ':' + p.tone;
    counters[k] = ((counters[k] === undefined ? -1 : counters[k]) + 1) % list.length;
    var body = list[counters[k]];
    var out = '';
    if (p.to) out += SALUTE[p.tone] + ' ' + p.to + ',\n\n';
    out += body;
    if (p.from) out += '\n\n' + (SIGN[p.tone] ? SIGN[p.tone] + '\n' : '') + p.from;
    return out;
  }

  function aiMessage(endpoint, p) {
    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(p)
    }).then(function (r) {
      if (!r.ok) throw new Error('bad response');
      return r.json();
    }).then(function (d) {
      if (!d || !d.message) throw new Error('empty');
      return String(d.message).trim();
    });
  }

  function init(root) {
    if (root.__ngReady) return;
    root.__ngReady = true;
    var endpoint = (root.getAttribute('data-endpoint') || '').trim();
    var form = root.querySelector('[data-ng-form]');
    var note = root.querySelector('[data-ng-note]');
    var actions = root.querySelector('[data-ng-actions]');
    var status = root.querySelector('[data-ng-status]');
    var hint = root.querySelector('[data-ng-hint]');
    var genBtn = root.querySelector('[data-ng-generate]');
    var saveBtn = root.querySelector('[data-ng-save]');
    var anotherBtn = root.querySelector('[data-ng-another]');
    var details = root.querySelector('[data-ng-details]');
    var playful = root.querySelector('[data-tone-playful]');
    var occasion = form.elements.occasion;

    if (endpoint && details) details.hidden = false;

    function params() {
      var tone = (form.querySelector('input[name="tone"]:checked') || {}).value || 'warm';
      return {
        to: form.elements.to.value.trim(),
        from: form.elements.from.value.trim(),
        occasion: occasion.value,
        tone: tone,
        details: form.elements.details ? form.elements.details.value.trim() : ''
      };
    }

    function say(msg, html) {
      if (html) status.innerHTML = msg; else status.textContent = msg;
    }

    function syncTones() {
      var sad = occasion.value === 'sympathy';
      playful.hidden = sad;
      if (sad) {
        var r = form.querySelector('input[name="tone"][value="playful"]');
        if (r && r.checked) form.querySelector('input[name="tone"][value="warm"]').checked = true;
      }
    }

    var gateAfter = parseInt(root.getAttribute('data-gate-after'), 10) || 0;
    var gateBox = root.querySelector('[data-ng-gate]');
    function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
    function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
    if (root.querySelector('[data-ng-unlocked]')) lsSet('notable-ng-unlocked', '1');
    function gated() { return gateAfter > 0 && gateBox && lsGet('notable-ng-unlocked') !== '1' && (parseInt(lsGet('notable-ng-count'), 10) || 0) >= gateAfter; }
    function generate() {
      if (gated()) { gateBox.hidden = false; gateBox.scrollIntoView({ block: 'center', behavior: 'smooth' }); return; }
      lsSet('notable-ng-count', String((parseInt(lsGet('notable-ng-count'), 10) || 0) + 1));
      var p = params();
      say('');
      genBtn.disabled = true;
      var done = function (text, usedFallback) {
        note.value = text;
        actions.hidden = false;
        var rm = root.querySelector('[data-ng-remind]'); if (rm) rm.hidden = false;
        genBtn.disabled = false;
        genBtn.textContent = 'Write it again';
        hint.textContent = 'Edit it however you like, then save it to your order. We will letter it by hand on a Notable card.';
        if (usedFallback) say('We used one of our own messages this time.');
      };
      if (endpoint) {
        aiMessage(endpoint, p).then(function (t) { done(t, false); }).catch(function () { done(localMessage(p), true); });
      } else {
        done(localMessage(p), false);
      }
    }

    function save() {
      var text = note.value.trim();
      if (!text) { say('Write or generate a note first.'); return; }
      var p = params();
      saveBtn.disabled = true;
      say('Saving…');
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'Gift note': text, 'Note to': p.to, 'Note from': p.from } })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        try { localStorage.setItem('notable-gift-note', text); } catch (e) {}
        say('Saved to your order. Now choose a bouquet and we will add this note to it. <a href="/pages/occasions">Shop by occasion</a>', true);
      }).catch(function () {
        say('We could not save that just now. Please try again.');
      }).then(function () { saveBtn.disabled = false; });
    }

    var rf = root.querySelector('.notable-ng__remind');
    if (rf) rf.addEventListener('submit', function () {
      var tags = rf.querySelector('[data-remind-tags]'), d = rf.querySelector('[data-remind-date]');
      var extra = ['occasion-' + occasion.value];
      if (d && d.value) extra.push('remind-' + d.value);
      if (tags) tags.value = tags.dataset.base + ', ' + extra.join(', ');
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); generate(); });
    anotherBtn.addEventListener('click', generate);
    saveBtn.addEventListener('click', save);
    occasion.addEventListener('change', syncTones);
    syncTones();

    try {
      var saved = localStorage.getItem('notable-gift-note');
      if (saved) { note.value = saved; actions.hidden = false; hint.textContent = 'Your saved note. Edit it or write a new one.'; }
    } catch (e) {}
  }

  function boot() { document.querySelectorAll('[data-notable-ng]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
